import type { SubscriptionFeature, SubscriptionTier } from './types';

export const TIER_FEATURES: Record<SubscriptionTier, SubscriptionFeature[]> = {
  free: ['basic_invoicing', 'customer_management', 'system_notifications', 'dvi'],
  pro: [
    'basic_invoicing',
    'customer_management',
    'system_notifications',
    'dvi',
    'dvi_photos',
    'reports',
    'labor_guide',
    'gross_profit',
    'time_tracking',
    'inventory',
    'team_management',
    'option_groups',
  ],
  elite: [
    'basic_invoicing',
    'customer_management',
    'customer_link_progress',
    'system_notifications',
    'dvi',
    'dvi_photos',
    'dvi_video',
    'reports',
    'sms',
    'multi_location',
    'ai_assistant',
    'ai_summary',
    'ai_suggested_jobs',
    'labor_guide',
    'gross_profit',
    'time_tracking',
    'tech_efficiency_report',
    'marketing',
    'dot_code_capture',
    'inventory',
    'team_management',
    'option_groups',
    'quickbooks',
  ],
};
